<template>
  <div>
    <v-btn
      v-show="GET_PRODUTOS_SELECIONADOS_COTACAO_PEDIDO.length > 0"
      color="red"
      dark
      small
      @click="deletarMultiplosItens()"
    >
      <v-icon class="mr-1" size="20">mdi-delete</v-icon>
      remover
      <span class="qtde-top-button-small">{{GET_PRODUTOS_SELECIONADOS_COTACAO_PEDIDO.length}}</span>
    </v-btn>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { deletarMultiplosItensCotacaoPedido } from "../CotacaoApi";

export default {
  computed: {
    ...mapGetters({
      GET_PRODUTOS_SELECIONADOS_COTACAO_PEDIDO: "CotacaoCarrinhoCompra/GET_PRODUTOS_SELECIONADOS_COTACAO_PEDIDO"
    })
  },
  methods: {
    ...mapMutations({
      SET_PRODUTOS_SELECIONADOS_COTACAO_PEDIDO: "CotacaoCarrinhoCompra/SET_PRODUTOS_SELECIONADOS_COTACAO_PEDIDO",
      SET_PRODUTOS_COTACAO_PEDIDO: "CotacaoCarrinhoCompra/SET_PRODUTOS_COTACAO_PEDIDO",
      SET_COTACOES_ID_PEDIDO: "CotacaoCarrinhoCompra/SET_COTACOES_ID_PEDIDO"
    }),
    deletarMultiplosItens() {
      this.$store.dispatch(
        "loading/addRequisicao",
        deletarMultiplosItensCotacaoPedido(this.GET_PRODUTOS_SELECIONADOS_COTACAO_PEDIDO)
          .then((retorno) => {
            this.SET_COTACOES_ID_PEDIDO(retorno.ids);
            this.SET_PRODUTOS_COTACAO_PEDIDO(retorno.produtos);
            this.SET_PRODUTOS_SELECIONADOS_COTACAO_PEDIDO([]);
          })
          .catch(() => this.Helpers.logout())
      );
    }
  }
}
</script>

<style>

</style>
